package com.rainbowclubs.rainbow.domain.use_cases.login

import com.rainbowclubs.rainbow.data.models.User
import com.rainbowclubs.rainbow.domain.repositories.UserRepository
import dev.gitlive.firebase.auth.AuthResult
import dev.gitlive.firebase.auth.FirebaseAuth

class CreateAccountUseCase(
    private val auth: FirebaseAuth,
    private val userRepository: UserRepository,
) {
    suspend operator fun invoke(
        username: String,
        password: String,
        displayName: String,
    ): Result<AuthResult> {
        try {
            val authResponse = auth.createUserWithEmailAndPassword(username, password)
            auth.currentUser?.updateProfile(displayName = displayName)
            val user = User(
                id = auth.currentUser?.uid,
                name = auth.currentUser?.displayName,
                email = auth.currentUser?.email,
                createdAt = null,
            )

            val response = userRepository.createUser(user)
            response.onSuccess {
                return Result.success(authResponse)
            }.onFailure {
                return Result.failure(it)
            }
            return Result.failure(Exception("Something went wrong"))
        } catch (e: Exception) {
            return Result.failure(e)
        }
    }
}
